import {
  Checkbox as MuiCheckbox,
  CheckboxProps,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Typography as MuiTypography,
  FormControlLabelProps,
} from '@mui/material';
import { forwardRef } from 'react';
import { svgBlankStyle, svgCheckedStyle, svgIndeterminateStyle } from './Checkbox.styles';
import { ECheckboxSize, ELabelTypographyVariant } from './checkbox.types';
import { BlankIcon } from './icons/BlankIcon';
import { CheckedIcon } from './icons/CheckedIcon';
import { IndeterminateIcon } from './icons/IndeterminateIcon';

export type CheckBoxProps = CheckboxProps & {
  label?: string;
  withLabel?: boolean;
  error?: boolean;
  helperText?: string;
  labelPlacement?: FormControlLabelProps['labelPlacement'];
};

export const defaultCheckboxProps = (props: CheckboxProps = {}) => {
  setCheckboxIcons(props);
  return props;
};

const setCheckboxIcons = (props: CheckboxProps) => {
  const iconSize = props.size === ECheckboxSize.medium ? 24 : 15;
  if (!props.icon) {
    props.icon = BlankIcon({
      sx: theme => svgBlankStyle(theme, iconSize, props.disabled),
    });
  }

  props.checkedIcon = CheckedIcon({
    sx: theme => svgCheckedStyle(theme, iconSize, props.disabled),
  });

  props.indeterminateIcon = IndeterminateIcon({
    sx: theme => svgIndeterminateStyle(theme, iconSize, props.disabled),
  });
};

const Typography = (text: string | undefined, fontSize: 'p12' | 'p16') => {
  return (
    <MuiTypography component="span" variant={fontSize}>
      {text}
    </MuiTypography>
  );
};

export const CheckBox = forwardRef<HTMLButtonElement, CheckBoxProps>(
  ({ label, withLabel, helperText, error, sx, labelPlacement, ...checkboxProps }, ref) => {
    const fontSize = checkboxProps.size
      ? ELabelTypographyVariant[checkboxProps.size]
      : ELabelTypographyVariant[ECheckboxSize.medium];
    setCheckboxIcons(checkboxProps);

    return (
      <FormControl error={error} sx={sx}>
        {withLabel ? (
          <FormControlLabel
            sx={{ marginLeft: '0' }}
            control={<MuiCheckbox {...checkboxProps} ref={ref} />}
            label={Typography(label, fontSize)}
            labelPlacement={labelPlacement}
          />
        ) : (
          <MuiCheckbox {...checkboxProps} ref={ref} />
        )}
        {helperText && <FormHelperText>{Typography(helperText, fontSize)}</FormHelperText>}
      </FormControl>
    );
  },
);
